// Limites operacionais do app-ponto. Use SEMPRE estes simbolos no api/web — nao redefina.
export const BIOMETRIA_THRESHOLD_DEFAULT = 0.6; // similaridade cosseno minima para aceitar match facial
export const MAX_FOTO_KB = 200; // tamanho max do JPEG/PNG enviado junto ao registro
export const SYNC_BATCH_SIZE = 50; // tamanho do lote enviado pelo cliente offline
export const GPS_ACCURACY_MAX_METROS = 100; // accuracy acima disto e considerada GPS ruim
export const OFFLINE_QUEUE_MAX = 500; // teto da fila Dexie no cliente
export const BIOMETRIA_EMBEDDING_LENGTHS = [128, 512];
// Verificação facial server-side (contrato FacialService)
export const FACIAL_THRESHOLD_DISTANCIA_DEFAULT = 0.5; // distancia euclidiana max p/ match
// Anti-fraude de relogio/deslocamento
export const MAX_SKEW_MS = 300_000; // 5min de desvio tolerado entre relogio do device e servidor
export const VELOCIDADE_MAX_KMH = 200; // acima disto = deslocamento impossivel entre batidas
// Limite da string base64 da foto de batida (~300KB de string ≈ 225KB de JPEG)
export const MAX_FOTO_BASE64_CHARS = 300_000;
export const HORARIO_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/; // HH:MM 24h
export const CPF_REGEX = /^\d{11}$/;
//# sourceMappingURL=constants.js.map